import { Component, h, Prop, Event, EventEmitter, State } from '@stencil/core';

@Component({
  tag: 'app-modal',
  styleUrl: 'style.scss',
  shadow: true,
  scoped: false
})
export class AppModal {
  @Prop() showModal: boolean;
  @Prop() showVideo: boolean;
  @Prop() videoSmall: string;
  @Prop() videoLarge: string;
  @Prop() videoOgg: string;
  @State() element: HTMLElement;

  @Event() closeModalEvent: EventEmitter;
  closeModal() {
    this.showModal = false;

    this.closeModalEvent.emit(this.showModal);
  }

  render() {
    return this.showModal ?
      <div
        class={
          {
            'modal': true,
            'modal-video': this.showVideo,
          }
        }
      >
        <button onClick={ this.closeModal.bind(this) }>Close</button>

        <div
          onClick={ this.closeModal.bind(this) }
          class='modal-overlay'
        />

        <div class='modal-content'>
          <slot />

          {
            this.videoSmall || this.videoLarge || this.videoOgg ?
              <div class='zento-video'>
                <video id='zento-video-1' controls autoplay>
                    <source src={ this.videoSmall } type='video/mp4' media='all and (max-width: 767px)' />
                    <source src={ this.videoLarge } type='video/mp4' media='all and (min-width: 768px)' />
                    <source src={ this.videoOgg } type='video/ogg' />
                </video>
              </div> :
              null
          }
        </div>
      </div> :
    null
  }
}
